
import Vue from 'vue'
import JcdcAlert from '@/components/jcdc/JcdcAlert.vue'

export default Vue.extend({
  name: 'JcdcError404',
  components: { JcdcAlert },
  props: {
    extHomeUrl: { type: String, default: undefined },
    resource: { type: String, default: 'resource' },
    errorCode: { type: Number, default: 404 },
  },
  computed: {
    prevPath() {
      const path = this.$route
      return path ? path.redirectedFrom : '/example-path'
    },
    homeRoute() {
      const path = this.$route
      if (path) {
        const x = path.matched[0],
          home = x.path ? { name: x.name } : x.redirect
        return home
      }
      return '/'
    },
  },
})
